<template>

    <table ref="table" @mouseup="onmouseup" @mousemove="onmousemove">
        <thead>
        <tr>
            <th v-for="(c, i) in cols"
                :key="i"
                :style="getStyleWidth(c)"
                :class="c.class" class="relative select-none text-sm">
                <div class="flex">
                    <slot :name="`th_${i}`" :context="c">
                        {{ c.name }}
                    </slot>

                    <span v-show="c.orderable" class="ml-2" @click.exact="reorder(i)">
                            <i class="fa fa-chevron-up transition-transform origin-center cursor-pointer"
                               :class="icon(i)"></i>
                        </span>
                </div>
                <span @mousedown.stop.prevent="onmousedown($event, c)" v-show="c.resizable"
                      class="z-10 absolute top-0 bottom-0 w-1.5 right-0 translate-x-2 bg-next-gray-md-darker rounded cursor-col-resize"></span>
            </th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(r, i) in rows" :key="i">
            <tr :class="r.tr_class">
                <td v-for="(c, j) in cols" :key="`${i}_${j}`" class="text-sm"
                    :class="c.td_class">
                    <slot :name="`td_${i}_${j}`" :context="{row: r, cell: c}">
                        {{ getVal(r,c.prop) }}
                    </slot>
                </td>
            </tr>
            <slot :name="`td_child_${i}`" :context="{row: r}">

            </slot>
        </template>
        </tbody>
    </table>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {TableColDef, TableOrder, TableRowDef} from "@/types";

@Options({
    name:'NextTable',
    props: {
        cols: Array,
        rows: Array,
        pagination: Object
    }
})
export default class NextTable extends Vue {
    cols!: TableColDef[]
    rows!: TableRowDef[]
    pagination !:any

    dragging?: MouseEvent;
    dragg_idx?: number;
    width = 0;

    resizing_initial_width = 0
    resizing_element: HTMLElement | null = null
    resizing_event: MouseEvent | null = null
    resizing_col_prop: string | null = null
    resizing_final: number | null = null

    field_order:any[] = []

    colWidth:any = []

    getVal(row:any, prop:string){
        const keys = prop.split('.'); // Dividi la stringa in un array di chiavi
        let value = row;

        for (const key of keys) {
            if (value && typeof value === 'object' && key in value) {
                value = value[key];
            } else {
                return undefined;
            }
        }

        return value;
    }

    getStyleWidth(h: TableColDef) {
        if (h.width) {
            return {
                'minWidth': `${h.width}px`
            }
        }
    }

    mounted() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        this.width = this.$refs.table.clientWidth
        const w = this.width / this.colWidth.length
        this.colWidth = this.cols.map(() => {
            return {actual: w, inc: 0}
        })
    }

    get isResizing() {
        return this.resizing_event != null
    }

    onmousedown(e: MouseEvent, h: TableColDef) {
        //@ts-ignore
        this.resizing_initial_width = e.target.parentNode.offsetWidth
        // @ts-ignore
        this.resizing_element = e.target.parentNode
        this.resizing_event = e
        this.resizing_col_prop = h.prop
    }

    onmouseup(e: MouseEvent) {
        if (this.isResizing) {
            e.preventDefault()
            e.stopPropagation()
            //@ts-ignore
            const diff = e.clientX - this.resizing_event.clientX
            if (this.resizing_element && this.resizing_col_prop) {
                this.updateColWidth(this.resizing_initial_width + diff)
            }
            this.resizing_event = null
            this.resizing_element = null
            this.resizing_initial_width = 0
            this.resizing_final = null
        }
    }

    onmousemove(e: MouseEvent) {
        if (this.isResizing) {
            e.preventDefault()
            e.stopPropagation()
            //@ts-ignore
            const diff = e.clientX - this.resizing_event.clientX
            if (this.resizing_element && this.resizing_col_prop) {
                this.updateColWidth(this.resizing_initial_width + diff, true)
            }
        }
    }

    updateColWidth(width: number, emit_sync?: boolean) {
        const resizing_col_def = this.cols.find((e) => e.prop == this.resizing_col_prop)
        if (resizing_col_def) {
            resizing_col_def.width = width
            this.updateCols(this.cols, emit_sync)
        }
    }

    updateCols(cols: any[], emit_sync = true) {
        if (emit_sync) {
            this.$emit('update:cols', cols)
        }
    }

    getWidth(i: number) {
        return `width: ${this.colWidth[i].actual + this.colWidth[i].inc}px`
    }

    icon(i: number) {
        const o = this.cols[i].order || TableOrder.NONE
        switch (o) {
            case TableOrder.NONE:
                return 'rotate-90';
            case TableOrder.ASC:
                return '';
            case TableOrder.DESC:
                return 'rotate-180'
        }
    }

    // reorderShift(i: number) {
    //     if (this.cols[i].orderable) {
    //         this.cols[i].order = this.cols[i].order || TableOrder.NONE
    //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //         //@ts-ignore
    //         this.cols[i].order = (++this.cols[i].order) % 3
    //         if(this.cols[i].order != TableOrder.NONE){
    //             this.field_order.push({col:i, ord:this.cols[i].order})
    //         }
    //         this.$emit('update:cols', this.field_order)
    //     }
    // }

    reorder(i: number) {
        if (!this.isResizing && this.cols[i].orderable) {
            this.cols[i].order = this.cols[i].order || TableOrder.NONE
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            this.cols[i].order = (++this.cols[i].order) % 3
            this.cols.forEach((c, j) => {
                if (i !== j) {
                    c.order = TableOrder.NONE
                }
            })
                // else {
            //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //         //@ts-ignore
            //         c.order = c.order || TableOrder.NONE
            //         c.order = (++c.order) % 3
            //     }
            //     return c
            // })
            this.$emit('order-update', {col:i, ord: this.cols[i].order })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
